<template>
  <div class="jc-page-header" >
    <h1>
      <a href="javascript:;" v-if="type=='back'" @click="backEvt">
        <i class="jc-icon-my-angle-left-bold"></i>
      </a>{{title}}
      <small v-if="!!childTitle">{{childTitle}}</small>
    </h1>
    <div class="jc-box-action">
      <a v-for="link in link" :href="link.url" class="blueLink" :target="link.target" :key="link">{{link.name}}</a>
      <router-link tag="a" href="javascript:;" v-for="link in routerLink" class="blueLink" :to="{path:link.url,query:link.param}" :key="link">{{link.name}}</router-link>
      <div class="right_link"><slot></slot></div>
    </div>
  </div>
</template>

<script>
import { isNull } from '@/utils'
export default {
  name: 'titleBar',
  data: function() {
    return {
      imgUlr: '/static/img/loading.png',
      backUrl: ''
    }
  },
  beforeRouteEnter(to, from) {
    this.backUrl = from.path
  },
  methods: {
    backEvt: function() {
      if (isNull(this.$store.state.backPath)) {
        history.go(-1)
      } else {
        this.$router.push({
          path: this.$store.state.backPath,
          query: this.$route.query
        })
      }
    }
  },
  props: ['title', 'childTitle', 'type', 'link', 'routerLink', 'param'],
  mounted: function() {}
}
</script>
<style type="text/css" scoped>
.indexTit h2 {
  float: left;
}
.indexTit .right_link {
  float: right;
  height: 26px;
  padding: 0 16px 0 0;
  line-height: 26px;
}
.indexTit .right_link a {
  margin: 0 0 0 16px;
  line-height: 26px;
}
</style>
